import React from 'react';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement,
  LineController, BarElement, Title, Tooltip, Legend, ArcElement, ChartData,
} from 'chart.js';
import { Bar, Doughnut } from 'react-chartjs-2';
import { DashboardProductResultDto } from '../../Dto_Home';
import { getMixedChartData, getBatchDefectDoughnutData } from '../../Utils_Home';
import { chartOptions } from '../A/ChartsSection_A';

ChartJS.register(
  CategoryScale, LinearScale, PointElement, LineElement, LineController,
  BarElement, Title, Tooltip, Legend, ArcElement
);

interface Props {
  monthlyProductionData: DashboardProductResultDto[];
  batchDefectData: DashboardProductResultDto[];
}

const ChartsSection_C: React.FC<Props> = ({ monthlyProductionData, batchDefectData }) => (
  <div className="grid grid-cols-2 gap-4 flex-1 min-h-0">
    <div className="bg-white rounded-lg p-3 shadow-sm flex flex-col min-h-0">
      <h2 className="text-lg font-semibold mb-2">브랜드별 생산실적 현황</h2>
      <div className="flex-1 min-h-0">
        <Bar
          data={getMixedChartData(monthlyProductionData) as unknown as ChartData<'bar'>}
          options={chartOptions.mixedChart}
        />
      </div>
    </div>
    <div className="bg-white rounded-lg p-3 shadow-sm flex flex-col min-h-0">
      <h2 className="text-lg font-semibold mb-2">품목그룹별 생산실적 현황</h2>
      <div className="flex-1 min-h-0">
        <Doughnut
          data={getBatchDefectDoughnutData(batchDefectData)}
          options={chartOptions.doughnutChart}
        />
      </div>
    </div>
  </div>
);

export default ChartsSection_C;
